import React, { useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { Icons } from '../shared/icons';
import { PLATFORM } from './content';
import './marketing.css';

const NAV = [
  { to: '/', label: 'Home', end: true },
  { to: '/features', label: 'Features' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/sign-up', label: 'Sign up' }
];

// Public marketing shell: header + <Outlet/> + footer. Routes live in
// src/routes.jsx as /, /features, /pricing, /sign-up — outside every auth
// gate, inside the same HashRouter (clean URLs work because main.jsx moves
// hashless pathnames into the hash before the router boots).
export default function MarketingLayout() {
  const [open, setOpen] = useState(false);

  return (
    <div className={`mk-page${open ? ' mk-header-open' : ''}`}>
      <header className="mk-header">
        <div className="mk-container mk-header-inner">
          <Link to="/" className="mk-brand" onClick={() => setOpen(false)}>
            <span className="mk-brand-mark">
              <SafeIcon icon={Icons.Droplet} />
            </span>
            <span>
              <span className="mk-brand-name">during.uk</span>
              <span className="mk-brand-tag">Client Portal</span>
            </span>
          </Link>

          <nav className="mk-nav" aria-label="Marketing navigation">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => (isActive ? 'mk-active' : '')}
                onClick={() => setOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="mk-header-actions">
            <Link to="/admin/login" className="mk-btn mk-btn-outline">
              <SafeIcon icon={Icons.LogIn} />
              Log in
            </Link>
            <Link to="/sign-up" className="mk-btn mk-btn-primary">
              Get started
            </Link>
            <button
              type="button"
              className="mk-burger"
              aria-label="Toggle menu"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
            >
              <SafeIcon icon={open ? Icons.X : Icons.Menu} />
            </button>
          </div>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="mk-footer">
        <div className="mk-container">
          <div className="mk-footer-grid">
            <div>
              <div className="mk-brand" style={{ marginRight: 0 }}>
                <span className="mk-brand-mark">
                  <SafeIcon icon={Icons.Droplet} />
                </span>
                <span>
                  <span className="mk-brand-name">during.uk</span>
                  <span className="mk-brand-tag">Client Portal</span>
                </span>
              </div>
              <p className="mk-footer-blurb" style={{ marginTop: 16 }}>
                {PLATFORM.tagline}. Invoices, certificates, engineer job sheets and client
                messaging — one platform, multi-tenant by design.
              </p>
            </div>

            <div>
              <h4>Product</h4>
              <ul className="mk-footer-links">
                <li><Link to="/features">Features</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/sign-up">Sign up</Link></li>
              </ul>
            </div>

            <div>
              <h4>Legal</h4>
              <ul className="mk-footer-links">
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
              </ul>
            </div>

            <div>
              <h4>Portals</h4>
              <ul className="mk-footer-links">
                <li><Link to="/portal/premiere">Client portal</Link></li>
                <li><Link to="/engineer/premiere">Engineer portal</Link></li>
                <li><Link to="/admin">Admin console</Link></li>
              </ul>
            </div>

            <div>
              <h4>Already a customer?</h4>
              <div className="mk-footer-login">
                <Link to="/admin/login" className="mk-btn mk-btn-lime">
                  <SafeIcon icon={Icons.LogIn} />
                  Log in to your portal
                </Link>
                <p>Agency &amp; staff sign-in — admin console, client portal and engineer
                portal. Clients: use the magic link from your email.</p>
              </div>
            </div>
          </div>

          <div className="mk-footer-bottom">
            <span>© {new Date().getFullYear()} {PLATFORM.shortName} — built for UK heating &amp; plumbing agencies.</span>
            <span>Gas Safe registered engineers · Statutory certificates · Stripe payments</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
